// extracted by mini-css-extract-plugin
module.exports = {"members-list":"PrivateChannelMembersModal_members-list__x08Pl"};